import breakpoints from "../../breakpoints";
import { ComponentsOverrides, Theme } from "@mui/material";
import { InternalThemeConfig } from "../../config";

const dialogTitle = ({ spacing }: InternalThemeConfig): ComponentsOverrides<Theme>["MuiDialogTitle"] => ({
	root: {
		paddingTop: "var(--panelOutSpacingVer)",
		paddingLeft: "var(--panelOutSpacingHor)",
		paddingRight: "var(--panelOutSpacingHor)",
		paddingBottom: "0",
		display: "flex",
		alignItems: "center",
		minHeight: "56px",
		"& $title": {
			fontWeight: 600,
			fontSize: "24px",
			lineHeight: "32px",
		},

		"@media (max-width:1140px)": {
			flexDirection: "column",
			alignItems: "flex-start",
			"& $formElements": {
				marginTop: spacing(4),
				marginBottom: spacing(-1),
				width: "100%",
				marginLeft: 0,
			},
		},

		[`@media (max-width:${breakpoints.values.md - 0.05}px)`]: {
			paddingTop: "6.4rem",
			paddingLeft: "calc(var(--panelOutSpacingHor) + var(--panelInSpacing))",
			paddingRight: "calc(var(--panelOutSpacingHor) + var(--panelInSpacing))",
		},
	},
});

export default dialogTitle;
